<template>
  <button :type="htmlType" :class="classes" :disabled="disabled" @click="_handleClick">
    <t-icon v-if="loading" :class="`${$constants.PREFIX_CLASS}ani-loop`" icon="loading"></t-icon>
    <t-icon v-if="icon && !loading" :icon="icon"></t-icon>
    <span v-if="showSlot" ref="slot"><slot></slot></span>
  </button>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import TIcon from '../icon'

const PREFIX_BUTTON_CLASS = `${PREFIX_CLASS}btn`

export default {
  name: 'TButton',
  components: {
    TIcon
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    block: {
      type: Boolean,
      default: false
    },
    htmlType: {
      type: String,
      default: 'button',
      validator (value) {
        /* istanbul ignore next */
        return [ 'button', 'submit', 'reset' ].includes(value)
      }
    },
    shape: {
      type: String,
      default: '',
      validator (value) {
        /* istanbul ignore next */
        return [ 'circle', 'round', '' ].includes(value)
      }
    },
    size: {
      type: String,
      default: '',
      validator (value) {
        /* istanbul ignore next */
        return [ 'sm', 'lg', '' ].includes(value)
      }
    },
    color: {
      type: String,
      default: 'secondary',
      validator (value) {
        /* istanbul ignore next */
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].includes(value)
      }
    },
    ghost: {
      type: Boolean,
      default: false
    },
    dashed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showSlot: true,
      clicking: false
    }
  },
  computed: {
    classes () {
      return [
        `${PREFIX_BUTTON_CLASS}`,
        {
          [`${PREFIX_BUTTON_CLASS}-${this.color}`]: !!this.color && !this.ghost && !this.dashed,
          [`${PREFIX_BUTTON_CLASS}-outline-${this.color}`]: !!this.color && this.ghost,
          [`${PREFIX_BUTTON_CLASS}-dashed-${this.color}`]: !!this.color && this.dashed,
          [`${PREFIX_BUTTON_CLASS}-block`]: this.block,
          [`${PREFIX_BUTTON_CLASS}-${this.shape}`]: !!this.shape,
          [`${PREFIX_BUTTON_CLASS}-${this.size}`]: !!this.size,
          [`${PREFIX_BUTTON_CLASS}-loading`]: this.loading != null && this.loading,
          [`active`]: this.clicking != null && this.clicking,
          [`${PREFIX_BUTTON_CLASS}-icon-only${this.size ? '-' + this.size : ''}`]: !this.showSlot && (!!this.icon || this.loading)
        }
      ]
    }
  },
  mounted () {
    this.showSlot = this.$slots.default !== undefined
  },
  methods: {
    _handleClick (event) {
      this.clicking = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => (this.clicking = false), 500)
      this.$emit('click', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/button/button.vue